<template>
    <div class="settings-header">
        <h1 class="settings-title">Settings</h1>
    </div>
</template>

<script>
export default {
    name: 'SettingsHeader'
};
</script>

<style scoped>
.settings-header {
    margin-bottom: 40px;
    padding-bottom: 30px;
    border-bottom: 1px solid rgba(var(--accent-rgb), 0.6);
}

.settings-title {
    font-size: 32px;
    color: var(--text-primary);
    margin: 0 0 10px 0;
}
</style>
